module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;
  },

  flipVertical: function (element) {
    this.canvas.selectOnly([element]);
    this.canvas.setFlip('v');
    this.trigger('flip_vertical');
  },

  flipHorizontal: function (element) {
    this.canvas.selectOnly([element]);
    this.canvas.setFlip('h');
    this.trigger('flip_horizontal');
  },

  convertToImageBox: function (element) {
    var clipPathBB = this.canvas.getBBox(element);

    var rect = this.canvas.copyElem(element);
    rect.removeAttribute('stroke');
    rect.removeAttribute('stroke-width');
    rect.removeAttribute('stroke-dasharray');
    rect.removeAttribute('stroke-linejoin');
    rect.removeAttribute('stroke-linecap');
    rect.removeAttribute('stroke-opacity');
    rect.removeAttribute('fill');
    rect.setAttribute('fill-opacity', '1');

    this.canvas.deleteSelectedElements();
    rect.removeAttribute('id');

    var layoutBox = this.canvas.runExtensions('addLayoutBox', {
      elem: rect,
      clipPathBB: clipPathBB
    });

    INKIVE.Tool.autoSave(rect);
  }
}, Backbone.Events);
